webpackJsonp([22676092666560,60335399758886],{

/***/ 179:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(345);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(179);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(681)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(685);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_PureComponent) {
	  _inherits(Container, _PureComponent);
	
	  function Container() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Container);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], _this.subscribers = [], _this.subscribe = function (handler) {
	      _this.subscribers = _this.subscribers.concat(handler);
	    }, _this.unsubscribe = function (handler) {
	      _this.subscribers = _this.subscribers.filter(function (current) {
	        return current !== handler;
	      });
	    }, _this.notifySubscribers = function (evt) {
	      if (!_this.framePending) {
	        var currentTarget = evt.currentTarget;
	
	
	        (0, _raf2.default)(function () {
	          _this.framePending = false;
	
	          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	              top = _this$node$getBoundin.top,
	              bottom = _this$node$getBoundin.bottom;
	
	          _this.subscribers.forEach(function (handler) {
	            return handler({
	              distanceFromTop: top,
	              distanceFromBottom: bottom,
	              eventSource: currentTarget === window ? document.body : _this.node
	            });
	          });
	        });
	        _this.framePending = true;
	      }
	    }, _this.getParent = function () {
	      return _this.node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Container, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        subscribe: this.subscribe,
	        unsubscribe: this.unsubscribe,
	        getParent: this.getParent
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.events.forEach(function (event) {
	        return window.addEventListener(event, _this2.notifySubscribers);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      this.events.forEach(function (event) {
	        return window.removeEventListener(event, _this3.notifySubscribers);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement('div', _extends({}, this.props, {
	        ref: function ref(node) {
	          return _this4.node = node;
	        },
	        onScroll: this.notifySubscribers,
	        onTouchStart: this.notifySubscribers,
	        onTouchMove: this.notifySubscribers,
	        onTouchEnd: this.notifySubscribers
	      }));
	    }
	  }]);
	
	  return Container;
	}(_react.PureComponent);
	
	Container.childContextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Container;

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSticky: false,
	      wasSticky: false,
	      style: {}
	    }, _this.handleContainerEvent = function (_ref2) {
	      var distanceFromTop = _ref2.distanceFromTop,
	          distanceFromBottom = _ref2.distanceFromBottom,
	          eventSource = _ref2.eventSource;
	
	      var parent = _this.context.getParent();
	
	      var preventingStickyStateChanges = false;
	      if (_this.props.relative) {
	        preventingStickyStateChanges = eventSource !== parent;
	        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
	      }
	
	      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
	      var contentClientRect = _this.content.getBoundingClientRect();
	      var calculatedHeight = contentClientRect.height;
	
	      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
	
	      var wasSticky = !!_this.state.isSticky;
	      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
	
	      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	      var style = !isSticky ? {} : {
	        position: 'fixed',
	        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
	        left: placeholderClientRect.left,
	        width: placeholderClientRect.width
	      };
	
	      if (!_this.props.disableHardwareAcceleration) {
	        style.transform = 'translateZ(0)';
	      }
	
	      _this.setState({
	        isSticky: isSticky,
	        wasSticky: wasSticky,
	        distanceFromTop: distanceFromTop,
	        distanceFromBottom: distanceFromBottom,
	        calculatedHeight: calculatedHeight,
	        style: style
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sticky, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	      this.context.subscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.unsubscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var element = _react2.default.cloneElement(this.props.children({
	        isSticky: this.state.isSticky,
	        wasSticky: this.state.wasSticky,
	        distanceFromTop: this.state.distanceFromTop,
	        distanceFromBottom: this.state.distanceFromBottom,
	        calculatedHeight: this.state.calculatedHeight,
	        style: this.state.style
	      }), { ref: function ref(content) {
	          _this2.content = _reactDom2.default.findDOMNode(content);
	        } });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: function ref(placeholder) {
	            return _this2.placeholder = placeholder;
	          } }),
	        element
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.propTypes = {
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  relative: _propTypes2.default.bool,
	  children: _propTypes2.default.func.isRequired
	};
	Sticky.defaultProps = {
	  relative: false,
	  topOffset: 0,
	  bottomOffset: 0,
	  disableCompensation: false,
	  disableHardwareAcceleration: false
	};
	Sticky.contextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Sticky;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyContainer = exports.Sticky = undefined;
	
	var _Sticky = __webpack_require__(793);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	var _Container = __webpack_require__(792);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _Sticky2.default;
	exports.StickyContainer = _Container2.default;
	exports.default = _Sticky2.default;

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var staticUrls = __webpack_require__(10);
	/** ELEMENTY MENU APLIKACJA */
	exports.APLIKACJA_MENU_WIDE_ITEM_ELEMENTS = [{
	    elementName: 'Cennik',
	    elementLinkTo: staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'Program do faktur',
	    elementLinkTo: staticUrls.FAKTUROMANIA_PROGRAM_DO_FAKTUR_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'O nas',
	    elementLinkTo: staticUrls.FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'Regulaminy',
	    elementLinkTo: 'elementLinkTo',
	    elementChildren: [{
	        elementName: 'Regulamin serwisu',
	        elementLinkTo: staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL,
	        elementLinkNoFollow: true
	    }, {
	        elementName: 'Polityka cookies',
	        elementLinkTo: staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL,
	        elementLinkNoFollow: true
	    }]
	}];
	/** ELEMENTY MENU TWOJA SPÓŁKA */
	exports.TWOJA_SPOLKA_MENU_WIDE_ITEM_ELEMENTS = [];
	/** ELEMENTY MENU KALKULATORY */
	exports.KALKULATORY_MENU_WIDE_ITEM_ELEMENTS = [{
	    elementName: 'Kalkulator wynagrodzeń',
	    elementLinkTo: staticUrls.FAKTUROMANIA_KALKULATOR_WYNAGRODZEN_PAGE_URL,
	    elementChildren: []
	}];
	/** ELEMENTY MENU USŁUGI */
	exports.USLUGI_MENU_DROPDOWN_ITEM_ELEMENTS = [];
	exports.USLUGI_SMALL_DEVICES_MENU_DROPDOWN_ITEM_ELEMENTS = [{
	    elementName: 'Rejestracja spółek',
	    elementLinkTo: staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'Biuro rachunkowe',
	    elementLinkTo: staticUrls.FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL,
	    elementChildren: []
	}];
	/** ELEMENTY MENU BIURO_WIRTUALNE */
	exports.BIURO_WIRTUALNE_MENU_DROPDOWN_ITEM_ELEMENTS = [];
	/** ELEMENTY MENU POMOC */
	exports.POMOC_MENU_DROPDOWN_ITEM_ELEMENTS = [{
	    elementName: 'Baza wiedzy',
	    elementLinkTo: staticUrls.FAKTUROMANIA_BAZA_WIEDZY_PAGE_URL,
	    elementLinkOpenInNewTab: true,
	    elementChildren: []
	}, {
	    elementName: 'Materiały szkoleniowe',
	    elementLinkTo: staticUrls.FAKTUROMANIA_YOUTUBE_PAGE_URL,
	    elementLinkOpenInNewTab: true,
	    elementLinkNoFollow: true,
	    elementChildren: []
	}];
	/** ELEMENTY MENU KONTAKT */
	exports.KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS = [];
	/** ELEMENTY DO MENU NA MAŁE EKRANY */
	exports.SMALL_DEVICE_MENU_DROPDOWN_ITEM_ELEMENTS = [{
	    elementName: 'Cennik',
	    elementLinkTo: staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'Program do faktur',
	    elementLinkTo: staticUrls.FAKTUROMANIA_PROGRAM_DO_FAKTUR_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'O nas',
	    elementLinkTo: staticUrls.FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL,
	    elementChildren: []
	}, {
	    elementName: 'Regulamin serwisu',
	    elementLinkTo: staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL,
	    elementLinkNoFollow: true
	}, {
	    elementName: 'Polityka cookies',
	    elementLinkTo: staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL,
	    elementLinkNoFollow: true
	}];

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-top: 120px;\n"], ["\n  margin-top: 120px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(34);
	var companyData = __webpack_require__(37);
	var staticUrls = __webpack_require__(10);
	var google_analytics_1 = __webpack_require__(27);
	var googleAnalyticsService = __webpack_require__(8);
	var cookieConsentService = __webpack_require__(213);
	var styled_components_1 = __webpack_require__(2);
	
	var Footer = function (_React$Component) {
	    _inherits(Footer, _React$Component);
	
	    function Footer(props) {
	        _classCallCheck(this, Footer);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onNavigateToSocialClick = _this.onNavigateToSocialClick.bind(_this);
	        _this.onCookiePreferencesClick = _this.onCookiePreferencesClick.bind(_this);
	        return _this;
	    }
	
	    Footer.prototype.onComponentView = function onComponentView() {
	        googleAnalyticsService.trackEvent(google_analytics_1.GoogleAnalyticsEventType.PageFooterViewed);
	    };
	
	    Footer.prototype.onNavigateToSocialClick = function onNavigateToSocialClick() {
	        googleAnalyticsService.trackEvent(google_analytics_1.GoogleAnalyticsEventType.PageFooterNavigateToSocialClicked);
	    };
	    /** ODNOŚNIK „PREFERENCJE PLIKÓW COOKIES” => OTWIERA USTAWIENIA BANERA (Polityka cookies § 3 ust. 4) */
	
	
	    Footer.prototype.onCookiePreferencesClick = function onCookiePreferencesClick(event) {
	        event.preventDefault();
	        cookieConsentService.showCookieSettings();
	    };
	
	    Footer.prototype.render = function render() {
	        return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(FooterWrapper, { className: "footer" }, React.createElement("div", { className: "footer-elements" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-12" }, React.createElement("div", { className: "row no-gutter" }, React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-element" }, React.createElement("span", { className: "typcn typcn-watch" }), React.createElement(StyledDataParagraph, null, companyData.FAKTUROMANIA_APP_COMPANY_WORKING_DAYS, React.createElement("span", null, companyData.FAKTUROMANIA_APP_COMPANY_WORKING_HOURS)))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-element" }, React.createElement("span", { className: "typcn typcn-location-outline" }), React.createElement(StyledDataParagraph, null, companyData.FAKTUROMANIA_APP_COMPANY_STREET_SHORT, React.createElement("span", null, companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CODE, " ", companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_SHORT)))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-element" }, React.createElement("span", { className: "typcn typcn-mail" }), React.createElement(StyledDataParagraph, null, "E-MAIL:", React.createElement("span", null, React.createElement("a", { href: "" }, companyData.FAKTUROMANIA_APP_COMPANY_EMAIL))))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-element" }, React.createElement("span", { className: "typcn typcn-phone-outline" }), React.createElement(StyledDataParagraph, null, "ZADZWO\u0143:", React.createElement("span", null, companyData.FAKTUROMANIA_APP_COMPANY_PHONE)))))))), React.createElement("div", { className: "footer-widgets" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-widget" }, React.createElement("h5", null, "O NAS"), React.createElement("p", null, "Fakturomania to pe\u0142na ksi\u0119gowo\u015B\u0107 online - aplikacja webowa, kt\xF3ra nie wymaga posiadania specjalistycznej wiedzy z zakresu rachunkowo\u015Bci i prawa."))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-widget" }, React.createElement("h5", null, "INFORMACJE"), React.createElement("ul", { className: "posts" }, React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL, rel: "nofollow" }, "REGULAMIN SERWISU")), React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL, rel: "nofollow" }, "POLITYKA COOKIES")), React.createElement("li", null, React.createElement("a", { href: "#", role: "button", onClick: this.onCookiePreferencesClick }, "PREFERENCJE PLIK\xD3W COOKIES")), React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_DOTACJE_PAGE_URL }, "PROJEKT POIG 8.2"))))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-widget" }, React.createElement("h5", null, "LINKI"), React.createElement("ul", { className: "posts" }, React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_FUNKCJE_PAGE_URL }, "FUNKCJE")), React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL }, "CENNIK")), React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_FAQ_PAGE_URL }, "FAQ")), React.createElement("li", null, React.createElement("a", { href: staticUrls.FAKTUROMANIA_BAZA_WIEDZY_PAGE_URL, target: "_blank" }, "BAZA WIEDZY")), React.createElement("li", null, React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL }, "KONTAKT"))))), React.createElement("div", { className: "col-sm-3" }, React.createElement("div", { className: "footer-widget" }, React.createElement("h5", null, "DANE FIRMY"), React.createElement("p", null, companyData.FAKTUROMANIA_APP_COMPANY_NAME), React.createElement("p", null, companyData.FAKTUROMANIA_APP_COMPANY_STREET_FULL), React.createElement("p", null, companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CODE, " ", companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_FULL), React.createElement("p", null, "NIP: ", companyData.FAKTUROMANIA_APP_COMPANY_NIP), React.createElement("p", null, "Kapita\u0142 zak\u0142adowy: ", companyData.FAKTUROMANIA_APP_COMPANY_SHARE_CAPITAL), React.createElement("br", null), React.createElement("h5", null, "POZNAJ NAS"), React.createElement("div", { className: "materialize-theme-styles" }, React.createElement("ul", { className: "social-link tt-animate ltr" }, React.createElement("li", null, React.createElement("a", { href: staticUrls.FAKTUROMANIA_FACEBOOK_PAGE_URL, target: "_blank", rel: "nofollow", onClick: this.onNavigateToSocialClick }, React.createElement("i", { className: "fa fa-facebook" })))))))))));
	    };
	
	    return Footer;
	}(React.Component);
	/** STYLES */
	
	
	var FooterWrapper = styled_components_1.default.section(_templateObject);
	var StyledDataParagraph = styled_components_1.default.p(_templateObject2);
	exports.default = Footer;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  a.menu-element-nested {\n    text-transform: none !important;\n    height: auto !important;\n    line-height: 29px !important;\n  }\n"], ["\n  a.menu-element-nested {\n    text-transform: none !important;\n    height: auto !important;\n    line-height: 29px !important;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var header_megamenu_dropdown_1 = __webpack_require__(211);
	var styled_components_1 = __webpack_require__(2);
	
	var HeaderMegamenuDropdownItemMenuElementNested = function (_React$Component) {
	    _inherits(HeaderMegamenuDropdownItemMenuElementNested, _React$Component);
	
	    function HeaderMegamenuDropdownItemMenuElementNested(props) {
	        _classCallCheck(this, HeaderMegamenuDropdownItemMenuElementNested);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            active: false
	        };
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        return _this;
	    }
	
	    HeaderMegamenuDropdownItemMenuElementNested.prototype.onMouseEnter = function onMouseEnter() {
	        this.setState({ active: true });
	    };
	
	    HeaderMegamenuDropdownItemMenuElementNested.prototype.onMouseLeave = function onMouseLeave() {
	        this.setState({ active: false });
	    };
	
	    HeaderMegamenuDropdownItemMenuElementNested.prototype.render = function render() {
	        var _props = this.props,
	            menuElement = _props.menuElement,
	            handleHeaderMenuElementSelection = _props.handleHeaderMenuElementSelection;
	        var active = this.state.active;
	        // ELEMENT VARIABLES
	
	        var hasChildren = menuElement.elementChildren && menuElement.elementChildren.length > 0;
	        var linkProps = {
	            onClick: function onClick() {
	                return !hasChildren && !menuElement.elementLinkOpenInNewTab ? handleHeaderMenuElementSelection(menuElement.elementLinkTo) : undefined;
	            },
	            target: menuElement.elementLinkOpenInNewTab ? "_blank" : "_self",
	            rel: menuElement.elementLinkNoFollow ? "nofollow" : undefined,
	            href: menuElement.elementLinkOpenInNewTab ? menuElement.elementLinkTo : undefined
	        };
	        return React.createElement(HeaderMegamenuDropdownItemMenuElementNestedWrapper, { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }, React.createElement("a", _extends({}, linkProps, { className: "menu-element-nested" }), menuElement.elementName, hasChildren && React.createElement("span", { className: "indicator" }, React.createElement("i", { className: "fa fa-angle-right" }))), hasChildren && React.createElement("ul", { className: "dropdown", style: active ? header_megamenu_dropdown_1.ActiveStyle : header_megamenu_dropdown_1.InactiveStyle }, menuElement.elementChildren.map(function (element, index) {
	            return React.createElement(HeaderMegamenuDropdownItemMenuElementNested, { key: index, menuElement: element, handleHeaderMenuElementSelection: handleHeaderMenuElementSelection });
	        })));
	    };
	
	    return HeaderMegamenuDropdownItemMenuElementNested;
	}(React.Component);
	/** STYLES => HeaderMegamenuDropdownItemMenuElementNested */
	
	
	var HeaderMegamenuDropdownItemMenuElementNestedWrapper = styled_components_1.default.li(_templateObject);
	var HeaderMegamenuDropdownItemMenuElement = function HeaderMegamenuDropdownItemMenuElement(props) {
	    var elements = props.elements,
	        handleHeaderMenuElementSelection = props.handleHeaderMenuElementSelection;
	
	    return React.createElement("ul", { className: "dropdown", style: header_megamenu_dropdown_1.ActiveStyle }, elements.map(function (element, index) {
	        return React.createElement(HeaderMegamenuDropdownItemMenuElementNested, { key: index, menuElement: element, handleHeaderMenuElementSelection: handleHeaderMenuElementSelection });
	    }));
	};
	exports.default = HeaderMegamenuDropdownItemMenuElement;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media (max-width: 1080px) {\n    a {\n      font-size: 13px !important;\n    }\n  }\n  @media (max-width: 1280px) {\n    a {\n      font-size: 14px !important;\n    }\n  }\n"], ["\n  @media (max-width: 1080px) {\n    a {\n      font-size: 13px !important;\n    }\n  }\n  @media (max-width: 1280px) {\n    a {\n      font-size: 14px !important;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(34);
	var header_megamenu_dropdown_item_menu_element_1 = __webpack_require__(342);
	var styled_components_1 = __webpack_require__(2);
	
	var HeaderMegamenuDropdown = function (_React$Component) {
	    _inherits(HeaderMegamenuDropdown, _React$Component);
	
	    function HeaderMegamenuDropdown(props) {
	        _classCallCheck(this, HeaderMegamenuDropdown);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            active: false
	        };
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        _this.handleHeaderMenuElementSelection = _this.handleHeaderMenuElementSelection.bind(_this);
	        return _this;
	    }
	
	    HeaderMegamenuDropdown.prototype.onMouseEnter = function onMouseEnter() {
	        this.setState({ active: true });
	    };
	
	    HeaderMegamenuDropdown.prototype.onMouseLeave = function onMouseLeave() {
	        this.setState({ active: false });
	    };
	
	    HeaderMegamenuDropdown.prototype.handleHeaderMenuElementSelection = function handleHeaderMenuElementSelection(dropdownLink) {
	        this.setState({ active: false });
	        gatsby_link_1.navigateTo(dropdownLink);
	    };
	
	    HeaderMegamenuDropdown.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            dropdownName = _props.dropdownName,
	            dropdownLink = _props.dropdownLink,
	            dropdownLinkOpenInNewTab = _props.dropdownLinkOpenInNewTab,
	            dropdownElements = _props.dropdownElements;
	        var active = this.state.active;
	        // COMPONENT VARIABLES
	
	        var hasChildren = dropdownElements && dropdownElements.length > 0;
	        return React.createElement(MenuListElementWrapper, { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }, !dropdownLinkOpenInNewTab && React.createElement("a", { onClick: function onClick() {
	                return dropdownLink && _this2.handleHeaderMenuElementSelection(dropdownLink);
	            } }, dropdownName, hasChildren && React.createElement("span", { className: "indicator" }, React.createElement("i", { className: "fa fa-angle-down" }))), dropdownLink && dropdownLinkOpenInNewTab && React.createElement("a", { href: dropdownLink, target: "_blank", rel: "nofollow" }, dropdownName, hasChildren && React.createElement("span", { className: "indicator" }, React.createElement("i", { className: "fa fa-angle-down" }))), React.createElement("ul", { className: "dropdown", style: active ? exports.ActiveStyle : exports.InactiveStyle }, React.createElement(header_megamenu_dropdown_item_menu_element_1.default, { elements: dropdownElements, handleHeaderMenuElementSelection: this.handleHeaderMenuElementSelection })));
	    };
	
	    return HeaderMegamenuDropdown;
	}(React.Component);
	/** STYLES */
	
	
	var MenuListElementWrapper = styled_components_1.default.li(_templateObject);
	exports.ActiveStyle = {
	    right: 'auto',
	    display: 'block'
	};
	exports.InactiveStyle = {};
	exports.default = HeaderMegamenuDropdown;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    height: 10px !important;\n  }\n  @media (min-width: 601px) and (max-width: 768px) {\n    height: 30px !important;\n  }\n  &[data-header-menu-is-sticky~=\"true\"] {\n    height: 63px;\n  }\n  &[data-header-menu-is-sticky~=\"false\"] {\n    height: 102px;\n  }\n"], ["\n  @media (max-width: 600px) {\n    height: 10px !important;\n  }\n  @media (min-width: 601px) and (max-width: 768px) {\n    height: 30px !important;\n  }\n  &[data-header-menu-is-sticky~=\"true\"] {\n    height: 63px;\n  }\n  &[data-header-menu-is-sticky~=\"false\"] {\n    height: 102px;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var HeaderPositioner = function HeaderPositioner(props) {
	  var headerMenuIsSticky = props.headerMenuIsSticky;
	
	  return React.createElement(HeaderPositionerWrapper, { "data-header-menu-is-sticky": headerMenuIsSticky });
	};
	/** STYLES */
	var HeaderPositionerWrapper = styled_components_1.default.div(_templateObject);
	exports.default = HeaderPositioner;

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0 20px !important;\n  width: 100% !important;\n  max-width: none !important;\n  display: flex;\n"], ["\n  padding: 0 20px !important;\n  width: 100% !important;\n  max-width: none !important;\n  display: flex;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 63px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 63px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  ul.menu-sm {\n    display: none;\n  }\n  @media (max-width: 799px) {\n    a {\n      font-size: 13px !important;\n    }\n    ul.menu-lg {\n      display: none;\n    }\n    ul.menu-sm {\n      display: initial;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  ul.menu-sm {\n    display: none;\n  }\n  @media (max-width: 799px) {\n    a {\n      font-size: 13px !important;\n    }\n    ul.menu-lg {\n      display: none;\n    }\n    ul.menu-sm {\n      display: initial;\n    }\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  &[data-header-is-sticky~=\"true\"] {\n    flex: 0 0 220px;\n    @media (max-width: 1320px) {\n      flex: 0 0 40px;\n    }\n  }\n  align-self: center;\n  border-right: 1px solid #dddddd;\n  display: flex;\n  align-items: center;\n  height: 100%;\n"], ["\n  &[data-header-is-sticky~=\"true\"] {\n    flex: 0 0 220px;\n    @media (max-width: 1320px) {\n      flex: 0 0 40px;\n    }\n  }\n  align-self: center;\n  border-right: 1px solid #dddddd;\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin: 0 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 1320px) {\n    margin-right: 16px !important;\n  }\n"], ["\n  margin: 0 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 1320px) {\n    margin-right: 16px !important;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 1320px) {\n    background-image: url(", ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 300px;\n    height: 80px;\n    &[data-header-is-sticky~=\"true\"] {\n      width: 220px;\n      height: 55px;\n    }\n  }\n  @media (max-width: 1320px) {\n    background-image: url(", ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 40px;\n    height: 40px;\n  }\n"], ["\n  @media (min-width: 1320px) {\n    background-image: url(", ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 300px;\n    height: 80px;\n    &[data-header-is-sticky~=\"true\"] {\n      width: 220px;\n      height: 55px;\n    }\n  }\n  @media (max-width: 1320px) {\n    background-image: url(", ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 40px;\n    height: 40px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  padding-left: 15px;\n  margin-right: auto;\n  @media (max-width: 599px) {\n    a {\n      height: 22px !important;\n      line-height: 22px !important;\n    }\n  }\n"], ["\n  padding-left: 15px;\n  margin-right: auto;\n  @media (max-width: 599px) {\n    a {\n      height: 22px !important;\n      line-height: 22px !important;\n    }\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-self: center;\n  padding-left: 20px;\n  a.register-button {\n    margin-right: 20px;\n  }\n  a {\n    margin-bottom: 0px;\n  }\n  &[data-header-is-sticky~=\"true\"] {\n    a {\n      height: 35px;\n      padding: 4px 13px;\n      font-size: 16px;\n      line-height: 25px;\n      border-radius: 2px;\n    }\n  }\n  @media (max-width: 599px) {\n    flex-direction: column;\n    justify-content: space-between;\n    a {\n      width: 100%;\n      height: 22px !important;\n      line-height: 22px !important;\n      padding: 0px 6px !important;\n    }\n    a:nth-of-type(1) {\n      margin-bottom: 4px;\n    }\n  }\n"], ["\n  display: flex;\n  align-self: center;\n  padding-left: 20px;\n  a.register-button {\n    margin-right: 20px;\n  }\n  a {\n    margin-bottom: 0px;\n  }\n  &[data-header-is-sticky~=\"true\"] {\n    a {\n      height: 35px;\n      padding: 4px 13px;\n      font-size: 16px;\n      line-height: 25px;\n      border-radius: 2px;\n    }\n  }\n  @media (max-width: 599px) {\n    flex-direction: column;\n    justify-content: space-between;\n    a {\n      width: 100%;\n      height: 22px !important;\n      line-height: 22px !important;\n      padding: 0px 6px !important;\n    }\n    a:nth-of-type(1) {\n      margin-bottom: 4px;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_sticky_1 = __webpack_require__(315);
	var header_megamenu_dropdown_1 = __webpack_require__(211);
	var gatsby_link_1 = __webpack_require__(34);
	var google_analytics_1 = __webpack_require__(27);
	var googleAnalyticsService = __webpack_require__(8);
	var staticUrls = __webpack_require__(10);
	var headerMenuData = __webpack_require__(332);
	var staticImages = __webpack_require__(33);
	var styled_components_1 = __webpack_require__(2);
	
	var StickyMenu = function (_React$Component) {
	  _inherits(StickyMenu, _React$Component);
	
	  function StickyMenu(props) {
	    _classCallCheck(this, StickyMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onAppRegisterButtonClick = _this.onAppRegisterButtonClick.bind(_this);
	    _this.onAppLoginButtonClick = _this.onAppLoginButtonClick.bind(_this);
	    return _this;
	  }
	
	  StickyMenu.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _props = this.props,
	        headerMenuIsSticky = _props.headerMenuIsSticky,
	        isSticky = _props.isSticky,
	        wasSticky = _props.wasSticky,
	        updateHeaderMenuState = _props.updateHeaderMenuState;
	    // WYWOŁYWANIE FUNKCJI TYLKO JEŚLI SIĘ COŚ ZMIENIŁO
	
	    if (isSticky != wasSticky && headerMenuIsSticky != isSticky) {
	      updateHeaderMenuState(isSticky, this.props);
	    }
	  };
	
	  StickyMenu.prototype.onAppRegisterButtonClick = function onAppRegisterButtonClick() {
	    googleAnalyticsService.trackEvent(google_analytics_1.GoogleAnalyticsEventType.NavigatedToAppRegisterPage);
	  };
	
	  StickyMenu.prototype.onAppLoginButtonClick = function onAppLoginButtonClick() {
	    googleAnalyticsService.trackEvent(google_analytics_1.GoogleAnalyticsEventType.NavigatedToAppLoginPage);
	  };
	
	  StickyMenu.prototype.render = function render() {
	    var _props2 = this.props,
	        pathName = _props2.pathName,
	        isSticky = _props2.isSticky,
	        style = _props2.style;
	
	    return React.createElement("div", { className: "materialize-theme-styles" }, React.createElement("header", { className: isSticky ? "tt-nav nav-border-bottom sticky" : "tt-nav nav-border-bottom", style: isSticky ? _extends({}, style, { width: "100%" }) : DefaultHeaderPositioningStyle }, React.createElement("div", { className: "header-sticky light-header", style: { width: "100%" } }, React.createElement(MenuContainerWrapper, { className: "container" }, React.createElement(MenuContainer, { className: "menuzord" }, React.createElement(LogoContainer, { "data-header-is-sticky": isSticky }, React.createElement(LinkContainer, { to: staticUrls.FAKTUROMANIA_LANDING_PAGE_URL, className: "logo-brand" }, React.createElement(LogoImageWrapper, { className: "retina", "data-header-is-sticky": isSticky }))), React.createElement(MenuContainerContentWrapper, null, React.createElement(NavigationMenuContainer, null, React.createElement("ul", { className: "menuzord-menu pull-right scrollable menu-lg" }, React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Aplikacja", dropdownElements: headerMenuData.APLIKACJA_MENU_WIDE_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Twoja spółka", dropdownLink: staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL, dropdownElements: headerMenuData.TWOJA_SPOLKA_MENU_WIDE_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Biuro rachunkowe", dropdownLink: staticUrls.FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL, dropdownElements: headerMenuData.USLUGI_MENU_DROPDOWN_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Kalkulatory", dropdownElements: headerMenuData.KALKULATORY_MENU_WIDE_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Pomoc", dropdownElements: headerMenuData.POMOC_MENU_DROPDOWN_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Kontakt", dropdownLink: staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL, dropdownElements: headerMenuData.KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS })), React.createElement("ul", { className: "menuzord-menu pull-right scrollable menu-sm" }, React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Info", dropdownElements: headerMenuData.SMALL_DEVICE_MENU_DROPDOWN_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Usługi", dropdownElements: headerMenuData.USLUGI_SMALL_DEVICES_MENU_DROPDOWN_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Pomoc", dropdownElements: headerMenuData.POMOC_MENU_DROPDOWN_ITEM_ELEMENTS }), React.createElement(header_megamenu_dropdown_1.default, { dropdownName: "Kontakt", dropdownLink: staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL, dropdownElements: headerMenuData.KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS }))), React.createElement(ApplicationMenuContainer, { "data-header-is-sticky": isSticky }, React.createElement("a", { className: "waves-effect waves-light btn register-button", href: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL, target: "_blank", onClick: this.onAppRegisterButtonClick }, "Rejestracja"), React.createElement("a", { className: "waves-effect waves-light btn login-button", href: staticUrls.FAKTUROMANIA_LOGIN_PAGE_URL, target: "_blank", onClick: this.onAppLoginButtonClick }, "Logowanie"))))))));
	  };
	
	  return StickyMenu;
	}(React.Component);
	
	var HeaderMenu = function (_React$Component2) {
	  _inherits(HeaderMenu, _React$Component2);
	
	  function HeaderMenu() {
	    _classCallCheck(this, HeaderMenu);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  HeaderMenu.prototype.render = function render() {
	    var _props3 = this.props,
	        pathName = _props3.pathName,
	        headerMenuIsSticky = _props3.headerMenuIsSticky,
	        updateHeaderMenuState = _props3.updateHeaderMenuState;
	
	    return React.createElement(react_sticky_1.Sticky, { topOffset: 46 }, function (stickyProps) {
	      return React.createElement(StickyMenu, _extends({}, stickyProps, { pathName: pathName, headerMenuIsSticky: headerMenuIsSticky, updateHeaderMenuState: updateHeaderMenuState }));
	    });
	  };
	
	  return HeaderMenu;
	}(React.Component);
	/** STYLES */
	
	
	var DefaultHeaderPositioningStyle = {
	  position: "fixed",
	  width: "100%"
	};
	var MenuContainerWrapper = styled_components_1.default.div(_templateObject);
	var MenuContainer = styled_components_1.default.div(_templateObject2);
	var MenuContainerContentWrapper = styled_components_1.default.div(_templateObject3);
	/** LogoContainer => LOGO */
	var LogoContainer = styled_components_1.default.div(_templateObject4);
	var LinkContainer = styled_components_1.default(gatsby_link_1.default)(_templateObject5);
	var LogoImageWrapper = styled_components_1.default.div(_templateObject6, staticImages.FAKTUROMANIA_LOGO_AND_NAME, staticImages.FAKTUROMANIA_LOGO_ICON);
	/** NavigationMenuContainer => MENU Z LINKAMI DO PODSTRON */
	var NavigationMenuContainer = styled_components_1.default.div(_templateObject7);
	/** ApplicationMenuContainer => MENU Z LINKAMI DO APLIKAJCI */
	var ApplicationMenuContainer = styled_components_1.default.div(_templateObject8);
	exports.default = HeaderMenu;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_sticky_1 = __webpack_require__(315);
	var top_bar_1 = __webpack_require__(359);
	var header_1 = __webpack_require__(344);
	var header_positioner_1 = __webpack_require__(343);
	var footer_1 = __webpack_require__(340);
	__webpack_require__(680);
	
	var DefaultLayout = function (_React$PureComponent) {
	    _inherits(DefaultLayout, _React$PureComponent);
	
	    function DefaultLayout(props) {
	        _classCallCheck(this, DefaultLayout);
	
	        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	        _this.state = {
	            headerMenuIsSticky: false
	        };
	        _this.updateHeaderMenuState = _this.updateHeaderMenuState.bind(_this);
	        return _this;
	    }
	
	    DefaultLayout.prototype.updateHeaderMenuState = function updateHeaderMenuState(isSticky, stickyProps) {
	        this.setState({ headerMenuIsSticky: isSticky });
	    };
	
	    DefaultLayout.prototype.render = function render() {
	        var _props = this.props,
	            location = _props.location,
	            children = _props.children;
	        var headerMenuIsSticky = this.state.headerMenuIsSticky;
	
	        return React.createElement(react_sticky_1.StickyContainer, { className: "index-layout-container" }, React.createElement(top_bar_1.default, null), React.createElement(header_1.default, { pathName: location.pathname, headerMenuIsSticky: headerMenuIsSticky, updateHeaderMenuState: this.updateHeaderMenuState }), React.createElement(header_positioner_1.default, { headerMenuIsSticky: headerMenuIsSticky }), children(), React.createElement(footer_1.default, null));
	    };
	
	    return DefaultLayout;
	}(React.PureComponent);
	
	exports.default = DefaultLayout;

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  div.row {\n    display: flex !important;\n    justify-content: space-between !important;\n    width: 100%;\n  }\n  @media (max-width: 768px) {\n    display: none;\n  }\n"], ["\n  div.row {\n    display: flex !important;\n    justify-content: space-between !important;\n    width: 100%;\n  }\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var companyData = __webpack_require__(37);
	var staticUrls = __webpack_require__(10);
	var styled_components_1 = __webpack_require__(2);
	var TopBar = function TopBar(props) {
	    return React.createElement("div", { className: "materialize-theme-styles" }, React.createElement(TopBarWrapper, { className: "top-bar light-blue" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-md-6" }, React.createElement("ul", { className: "list-inline social-top tt-animate btt" }, React.createElement("li", null, React.createElement("a", { href: staticUrls.FAKTUROMANIA_FACEBOOK_PAGE_URL, target: "_blank", rel: "nofollow" }, React.createElement("i", { className: "fa fa-facebook" }))), React.createElement("li", null, React.createElement("a", { href: staticUrls.FAKTUROMANIA_TWITTER_PAGE_URL, target: "_blank", rel: "nofollow" }, React.createElement("i", { className: "fa fa-twitter" }))), React.createElement("li", null, React.createElement("a", { href: staticUrls.FAKTUROMANIA_LINKED_IN_PAGE_URL, target: "_blank", rel: "nofollow" }, React.createElement("i", { className: "fa fa-linkedin" }))))), React.createElement(TopBarContactInfoWrapper, { className: "col-md-6 text-right" }, React.createElement("ul", { className: "topbar-cta no-margin" }, React.createElement("li", { className: "mr-20" }, React.createElement("a", null, React.createElement("i", { className: "material-icons mr-10" }, "\uE0B9"), "info@fakturomania.pl")), React.createElement("li", null, React.createElement("a", null, React.createElement("i", { className: "material-icons mr-10" }, "\uE0CD"), " +48 ", companyData.FAKTUROMANIA_APP_COMPANY_PHONE)))))));
	};
	/** STYLES */
	var TopBarWrapper = styled_components_1.default.div(_templateObject);
	var TopBarContactInfoWrapper = styled_components_1.default.div(_templateObject2);
	exports.default = TopBar;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-tsx-1ddc6839427531b8e66f.js